import { __assign } from "tslib";
import { agentStatsUrl, createChatDashboardApi } from '.';
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
export var createChatDashboardApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createChatDashboardApi(parent, fakeHttp);
    var base = "".concat(parent, "/dashboard/chat");
    var handler = {
        whenGetChatDashboardData: createFakePostResponder(fakeHttp, "".concat(base)),
        whenGetChatDashboardOveriew: createFakePostResponder(fakeHttp, "".concat(base)),
        whenGetAgentStats: createFakePostResponder(fakeHttp, "".concat(base).concat(agentStatsUrl)),
        whenGetAgentStatsNew: createFakePostResponder(fakeHttp, "".concat(base).concat(agentStatsUrl, "/new")),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map